import React from 'react';
import MapComponent from "components/MapComponent/MapComponent";
import MapWrapper from "layout/MapWrapper/MapWrapper";
import styles from "styles/pages/modal.module.scss";
import ModalWrapper from 'layout/ModalWrapper/ModalWrapper';
import CustomButton from 'ui/CustomButton/CustomButton';
import asset from "json/assets";

export default function ModalPage() {

    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };
    

    return (
        <MapWrapper title={'DRIVING RANGE'}>
            <MapComponent />
            <div className={styles.modal_btn_bar}>
                <button onClick={handleClickOpen}>modal</button>
            </div>
            
            <ModalWrapper 
            open={open}
            onClose={handleClose}
            handleClose={handleClose} 
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            
            >
                <div className={styles.modalMain}>
                    <div className={styles.modalHeader}>
                        <h4>Success</h4>
                    </div>
                    <div className={styles.modalBody}>
                        <div className={styles.modal_cont}>
                            <div className={styles.modal_cont_left}>
                                <img src={asset.update} alt="img" />
                            </div>
                            <div className={styles.modal_cont_right}>
                                <h2>Updating</h2>
                                <p>Settings were successfully updated</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.modalInputButton}>
                        <CustomButton>Update</CustomButton>
                    </div>
                </div>
            </ModalWrapper>
        </MapWrapper>
    );
}
